import { MarketplaceThemeType } from './sharedTypes'

// Heures IPERIA restantes du panier et formations déjà suivies (CRM `registration_group/iperia_eligibility`,
// ticket Notion #893). Le serveur décide ; ces fonctions ne font que l'appliquer à l'affichage.

export type IperiaCartStatus = 'ok' | 'partial' | 'none' | 'unavailable'

export type IperiaCartProduct = { product_code: string; hours: number; allowed: boolean }

export type IperiaCartEligibility = {
  /** Année de la première date de début possible, `null` si aucune ne l'est. */
  year: number | null
  cap_hours: number
  remaining_hours: number
  cart_hours: number
  status: IperiaCartStatus
  products: IperiaCartProduct[]
  next_year: { year: number; remaining_hours: number } | null
  /** Formations validées ou en cours : la marketplace ne les propose pas. */
  hidden_theme_codes?: string[]
  /** Formations terminées sans être validées : proposées après les autres, sans mention. */
  retake_theme_codes?: string[]
}

/** Retire les thèmes masqués et place ceux à reprendre après les autres, sans changer l'ordre de chacun. */
export const arrangeThemes = (
  themes: MarketplaceThemeType[],
  hidden: string[] = [],
  retake: string[] = [],
): MarketplaceThemeType[] => {
  const hiddenSet = new Set(hidden)
  const retakeSet = new Set(retake)
  const shown = themes.filter((theme) => !hiddenSet.has(theme.theme_code))
  return [
    ...shown.filter((theme) => !retakeSet.has(theme.theme_code)),
    ...shown.filter((theme) => retakeSet.has(theme.theme_code)),
  ]
}

/** Les formations du panier que le financement peut couvrir (une formation déjà financée dans l'année ne l'est pas). */
export const allowedProducts = (eligibility: IperiaCartEligibility): IperiaCartProduct[] =>
  eligibility.products.filter((product) => product.allowed)

export const keptHours = (eligibility: IperiaCartEligibility, kept: string[]): number =>
  allowedProducts(eligibility)
    .filter((product) => kept.includes(product.product_code))
    .reduce((total, product) => total + product.hours, 0)

/** La sélection tient dans les heures restantes et n'est pas vide. */
export const keptSelectionFits = (eligibility: IperiaCartEligibility, kept: string[]): boolean =>
  kept.length > 0 && keptHours(eligibility, kept) <= eligibility.remaining_hours

/** « 14 h », « 7,5 h » : les heures à la française. */
export const formatHours = (hours: number): string => `${String(Math.round(hours * 10) / 10).replace('.', ',')} h`
